import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const ReverseOsmosisRoPlants: React.FC = () => {
  return (
    <>
      <PageHeader title="Reverse Osmosis (RO) Plants" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-12">
                  <img className="img-fluid" src="img/ro.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Reverse Osmosis (RO) Plants</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Reverse Osmosis (RO) is a pressure-driven membrane separation process that removes dissolved salts, organic contaminants, heavy metals, and microorganisms from water. At Wasser Technochem (India) Ltd., we specialize in the design, engineering, installation, and commissioning of custom RO systems for industrial, commercial, and institutional applications.</p>
              <p>RO technology is essential wherever high-purity water is required or where brackish, borewell, or surface water needs to be treated to potable or process-grade quality.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-industry text-primary me-2"></i>Industrial process water for textiles, chemicals, food & beverages</p>
              <p><i className="fa fa-fire text-primary me-2"></i>Boiler feedwater treatment (HP & LP boilers)</p>
              <p><i className="fa fa-tint text-primary me-2"></i>Drinking water plants</p>
              <p><i className="fa fa-recycle text-primary me-2"></i>Effluent recycling in ZLD systems</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Pre-treatment for EDI or DM plants</p>
              <p><i className="fa fa-water text-primary me-2"></i>Desalination of brackish/saline water</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL offers skid-mounted, containerized, and modular RO plants with advanced automation and efficiency features.</p>
              
              <div className="mb-4">
                <h5><i className="fa fa-chart-line text-primary me-2"></i>Design Range: 0.5 m³/hr to 1000+ m³/hr</h5>
                <p className="ms-4">Based on TDS, recovery target, and industry norms.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-shield-alt text-primary me-2"></i>High-Rejection RO Membranes</h5>
                <p className="ms-4">From industry-leading brands (Veolia, Dow, Toray).</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-layer-group text-primary me-2"></i>Single Pass / Double Pass / Multi-Stage Systems</h5>
                <p className="ms-4">For brackish water, seawater, or wastewater recovery.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-bolt text-primary me-2"></i>Energy Recovery & Low Fouling Design</h5>
                <p className="ms-4">Ensuring minimal scaling, optimized pressure, and higher recovery.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-tools text-primary me-2"></i>Integrated CIP (Cleaning-in-Place)</h5>
                <p className="ms-4">For periodic membrane cleaning to extend lifespan.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cogs text-primary me-2"></i>Pre- and Post-Treatment Systems</h5>
                <p className="ms-4">Including ACF, MGF, dosing, degassers, and remineralization units.</p>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Produces low-TDS, high-purity water</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Cost-effective alternative to distillation or deionization</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compact, automated, and scalable</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Suitable for both greenfield and retrofit applications</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>25+ years of expertise in RO plant design and commissioning</p>
              <p><i className="fa fa-star text-warning me-2"></i>Proven results across power plants, bottling units, FMCG, and textiles</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house membrane diagnostics, cleaning, and AMC services</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Flexible financing, containerized units, and remote support options</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ReverseOsmosisRoPlants;
